export interface IEnvConfig {
  pomUrl: string;
  cfmUrl: string;
  stiftungUrl: string;
  noticeText: string;
  applicationInsightsConnectionString: string;
}

// Read per call rather than once at module load: env-config.js is written at deploy time and a
// cached snapshot would also survive between tests.
const readEnvVar = (key: string): string => window._env_?.[key]?.trim() ?? "";

export const getEnvConfig = (): IEnvConfig => ({
  pomUrl: readEnvVar("POM_URL"),
  cfmUrl: readEnvVar("CFM_URL"),
  stiftungUrl: readEnvVar("STIFTUNG_URL"),
  noticeText: readEnvVar("NOTICE_TEXT"),
  applicationInsightsConnectionString: readEnvVar("APPLICATIONINSIGHTS_CONNECTION_STRING"),
});
